import React from "react";
import {PaymentMethodTypes} from "../../../../enums";
import {Container} from "../../../../ui";
import {CustomDialog} from "../../../bounce-ui";
import {PaymentDetails, PaymentType} from "../../../declarations";
import {PaymentContext} from "../../payment";

interface IAddPaymentMethodDialogContent {
  accountId: string;
  title: string;
  submitTitle: string;
  currentMethodType?: PaymentMethodTypes;
  page: any;
  paymentPlanId: string;
  immediatePaymentAmount: string;
  inManagePaymentMethod: boolean;
  buttonTouched: boolean;
  setButtonTouched: (touched: boolean) => void;
  isLoading: boolean;
  paymentHandler: (paymentType: PaymentType, paymentDetails: PaymentDetails, isChangePaymentMethod: boolean) => void;
  PaymentMethod: React.ComponentType<{
    accountId: string;
    paymentHandler: (paymentType: PaymentType, paymentDetails: PaymentDetails, isChangePaymentMethod: boolean) => void;
    title: string;
    submitTitle: string;
    currentMethodType?: PaymentMethodTypes;
    page: any;
    paymentPlanId: string;
    immediatePaymentAmount: string;
  }>;
}

export const AddPaymentMethodDialogContent = ({
  accountId,
  title,
  submitTitle,
  currentMethodType,
  page,
  paymentPlanId,
  immediatePaymentAmount,
  inManagePaymentMethod,
  buttonTouched,
  setButtonTouched,
  isLoading,
  paymentHandler,
  PaymentMethod,
}: IAddPaymentMethodDialogContent) => {
  return (
    <PaymentContext.Provider value={{buttonTouched, setButtonTouched, isLoading}}>
      <CustomDialog title={inManagePaymentMethod ? "Add payment method" : "Payment method"}>
        <Container sx={{alignItems: "start", overflow: "auto"}}>
          <PaymentMethod
            accountId={accountId}
            paymentHandler={paymentHandler}
            title={title}
            submitTitle={submitTitle}
            currentMethodType={currentMethodType}
            page={page}
            paymentPlanId={paymentPlanId}
            immediatePaymentAmount={immediatePaymentAmount}
          />
        </Container>
      </CustomDialog>
    </PaymentContext.Provider>
  );
};
